
// @ts-nocheck


export const localeCodes =  [
  "en",
  "nl",
  "fr",
  "zh",
  "it",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_ea5e9db6",
      load: () => import("#nuxt-i18n/ea5e9db6" /* webpackChunkName: "locale_en_46json_ea5e9db6" */),
      cache: true
    },
    {
      key: "locale_en_46json_22304ca8",
      load: () => import("#nuxt-i18n/22304ca8" /* webpackChunkName: "locale_en_46json_22304ca8" */),
      cache: true
    },
    {
      key: "locale_en_46json_e9e3f96c",
      load: () => import("#nuxt-i18n/e9e3f96c" /* webpackChunkName: "locale_en_46json_e9e3f96c" */),
      cache: true
    },
    {
      key: "locale_en_46json_a84b5760",
      load: () => import("#nuxt-i18n/a84b5760" /* webpackChunkName: "locale_en_46json_a84b5760" */),
      cache: true
    },
    {
      key: "locale_messageLoader_46ts_8f67527f",
      load: () => import("#nuxt-i18n/8f67527f" /* webpackChunkName: "locale_messageLoader_46ts_8f67527f" */),
      cache: false
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_01baa770",
      load: () => import("#nuxt-i18n/01baa770" /* webpackChunkName: "locale_nl_46json_01baa770" */),
      cache: true
    },
    {
      key: "locale_nl_46json_18bc89c7",
      load: () => import("#nuxt-i18n/18bc89c7" /* webpackChunkName: "locale_nl_46json_18bc89c7" */),
      cache: true
    },
    {
      key: "locale_nl_46json_212b7eb5",
      load: () => import("#nuxt-i18n/212b7eb5" /* webpackChunkName: "locale_nl_46json_212b7eb5" */),
      cache: true
    },
    {
      key: "locale_nl_46json_4eac6212",
      load: () => import("#nuxt-i18n/4eac6212" /* webpackChunkName: "locale_nl_46json_4eac6212" */),
      cache: true
    },
    {
      key: "locale_messageLoader_46ts_8f67527f",
      load: () => import("#nuxt-i18n/8f67527f" /* webpackChunkName: "locale_messageLoader_46ts_8f67527f" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_5e222b09",
      load: () => import("#nuxt-i18n/5e222b09" /* webpackChunkName: "locale_fr_46json_5e222b09" */),
      cache: true
    },
    {
      key: "locale_fr_46json_f85e916d",
      load: () => import("#nuxt-i18n/f85e916d" /* webpackChunkName: "locale_fr_46json_f85e916d" */),
      cache: true
    },
    {
      key: "locale_fr_46json_2bb9a0d2",
      load: () => import("#nuxt-i18n/2bb9a0d2" /* webpackChunkName: "locale_fr_46json_2bb9a0d2" */),
      cache: true
    },
    {
      key: "locale_fr_46json_b68cd2a5",
      load: () => import("#nuxt-i18n/b68cd2a5" /* webpackChunkName: "locale_fr_46json_b68cd2a5" */),
      cache: true
    },
    {
      key: "locale_messageLoader_46ts_8f67527f",
      load: () => import("#nuxt-i18n/8f67527f" /* webpackChunkName: "locale_messageLoader_46ts_8f67527f" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_c870a35b",
      load: () => import("#nuxt-i18n/c870a35b" /* webpackChunkName: "locale_zh_46json_c870a35b" */),
      cache: true
    },
    {
      key: "locale_zh_46json_b8877896",
      load: () => import("#nuxt-i18n/b8877896" /* webpackChunkName: "locale_zh_46json_b8877896" */),
      cache: true
    },
    {
      key: "locale_zh_46json_cb0f89bd",
      load: () => import("#nuxt-i18n/cb0f89bd" /* webpackChunkName: "locale_zh_46json_cb0f89bd" */),
      cache: true
    },
    {
      key: "locale_zh_46json_8503dada",
      load: () => import("#nuxt-i18n/8503dada" /* webpackChunkName: "locale_zh_46json_8503dada" */),
      cache: true
    },
    {
      key: "locale_messageLoader_46ts_8f67527f",
      load: () => import("#nuxt-i18n/8f67527f" /* webpackChunkName: "locale_messageLoader_46ts_8f67527f" */),
      cache: false
    }
  ],
  it: [
    {
      key: "locale_it_46json_12be9333",
      load: () => import("#nuxt-i18n/12be9333" /* webpackChunkName: "locale_it_46json_12be9333" */),
      cache: true
    },
    {
      key: "locale_it_46json_687b6b93",
      load: () => import("#nuxt-i18n/687b6b93" /* webpackChunkName: "locale_it_46json_687b6b93" */),
      cache: true
    },
    {
      key: "locale_it_46json_e4fb74d5",
      load: () => import("#nuxt-i18n/e4fb74d5" /* webpackChunkName: "locale_it_46json_e4fb74d5" */),
      cache: true
    },
    {
      key: "locale_it_46json_d6232171",
      load: () => import("#nuxt-i18n/d6232171" /* webpackChunkName: "locale_it_46json_d6232171" */),
      cache: true
    },
    {
      key: "locale_messageLoader_46ts_8f67527f",
      load: () => import("#nuxt-i18n/8f67527f" /* webpackChunkName: "locale_messageLoader_46ts_8f67527f" */),
      cache: false
    }
  ],
  es: [
    {
      key: "locale_es_46json_b1e3356b",
      load: () => import("#nuxt-i18n/b1e3356b" /* webpackChunkName: "locale_es_46json_b1e3356b" */),
      cache: true
    },
    {
      key: "locale_es_46json_a447eca2",
      load: () => import("#nuxt-i18n/a447eca2" /* webpackChunkName: "locale_es_46json_a447eca2" */),
      cache: true
    },
    {
      key: "locale_es_46json_c1a59d39",
      load: () => import("#nuxt-i18n/c1a59d39" /* webpackChunkName: "locale_es_46json_c1a59d39" */),
      cache: true
    },
    {
      key: "locale_es_46json_1fe1e4c8",
      load: () => import("#nuxt-i18n/1fe1e4c8" /* webpackChunkName: "locale_es_46json_1fe1e4c8" */),
      cache: true
    },
    {
      key: "locale_messageLoader_46ts_8f67527f",
      load: () => import("#nuxt-i18n/8f67527f" /* webpackChunkName: "locale_messageLoader_46ts_8f67527f" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/membership/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/auth/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/layout/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/form/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      language: "nl-NL",
      name: "Nederlands",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/membership/i18n/locales/nl.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/auth/i18n/locales/nl.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/layout/i18n/locales/nl.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/form/i18n/locales/nl.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/membership/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/auth/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/layout/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/form/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      language: "zh-Hant",
      name: "繁體中文",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/membership/i18n/locales/zh.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/auth/i18n/locales/zh.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/layout/i18n/locales/zh.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/form/i18n/locales/zh.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      language: "it-IT",
      name: "Italiano",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/membership/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/auth/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/layout/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/form/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-US",
      name: "Español",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/membership/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/auth/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/layout/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/packages/form/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://www.citizenm.com",
  customRoutes: "config",
  pages: {
    "get-booking/reservations": {
      nl: "/get-booking/reserveringen",
      it: "/get-booking/prenotaziones",
      es: "/get-booking/reservas"
    },
    "get-booking/reservation": {
      nl: "/get-booking/reservering",
      it: "/get-booking/prenotazione",
      es: "/get-booking/reserva"
    },
    "get-booking/reservation-payment": {
      nl: "/get-booking/reservering-payment",
      it: "/get-booking/prenotazione-payment",
      es: "/get-booking/reserva-payment"
    },
    "my/profile": {
      nl: "/my/mijn-profiel",
      fr: "/my/mon-profil",
      it: "/my/il-mio-profilo",
      es: "/my/mi-perfil"
    },
    "my/reservations": {
      nl: "/my/mijn-reserveringen",
      fr: "/my/mes-reservations",
      it: "/my/le-mie-prenotazioni",
      es: "/my/mis-reservas"
    },
    "my/reservation-[reservationId]": {
      nl: "/my/mijn-reservering-[reservationId]",
      fr: "/my/ma-reservation-[reservationId]",
      it: "/my/la-mia-prenotazione-[reservationId]",
      es: "/my/mi-reserva-[reservationId]"
    },
    "my/booking-[reservationId]": {
      nl: "/my/mijn-boeking-[reservationId]"
    },
    "my/membership": {
      nl: "/my/lidmaatschap",
      fr: "/my/abonnement"
    },
    "hotels/index": {
      es: "/hoteles"
    },
    "hotels/[continent]/index": {
      es: "/hoteles/[continent]"
    },
    "hotels/[continent]/[city]/index": {
      es: "/hoteles/[continent]/[city]"
    },
    "hotels/[continent]/[city]/[hotelSlug]/index": {
      es: "/hoteles/[continent]/[city]/[hotelSlug]"
    },
    "hotels/[continent]/[city]/[hotelSlug]/[featureSlug]": {
      es: "/hoteles/[continent]/[city]/[hotelSlug]/[featureSlug]"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/membership/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/auth/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/layout/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/form/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    language: "nl-NL",
    name: "Nederlands",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/membership/i18n/locales/nl.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/auth/i18n/locales/nl.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/layout/i18n/locales/nl.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/form/i18n/locales/nl.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/membership/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/auth/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/layout/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/form/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    language: "zh-Hant",
    name: "繁體中文",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/membership/i18n/locales/zh.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/auth/i18n/locales/zh.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/layout/i18n/locales/zh.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/form/i18n/locales/zh.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/membership/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/auth/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/layout/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/form/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-US",
    name: "Español",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/membership/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/auth/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/layout/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/packages/form/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/home/vsts/work/1/s/apps/lobby/i18n/locales/messageLoader.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/